export default "//static.tradera.net/touchweb/static/output/images/category-handmade-applied-arts.345eee95.svg";